import React, { Component, Fragment } from 'react';

import {
  BarChart,
  Bar,
  ResponsiveContainer,
  YAxis,
  XAxis,
  LabelList,
  ReferenceLine
} from 'recharts';

import { Metric, selectFormat } from './../Utils/Utils.js';
import Heading from './../Elements/Heading';

class TopLTVCPA extends Component {
  labelFormatter = (value) => (
    selectFormat("currency", value)
  )

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <Heading size={6} className={'mb-1'} >
          Average
        </Heading>
        <Metric {...data.average} size={'md'} format={'$0.00'} />

        <ResponsiveContainer height={250}>
          <BarChart data={data.data} layout="vertical" margin={{ top: 10, right: 70, left: 100, bottom: 0 }} >

            <XAxis type="number" hide />
            <YAxis type="category" hide />

            <defs>
              <linearGradient id="orange-gradient" x1="0" y1="0" x2="1" y2="0">
                <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
              </linearGradient>
            </defs>

            <Bar dataKey="value" maxBarSize={26} fill="url(#orange-gradient)">
              <LabelList dataKey="value" position="right" offset={10} color='#4C595E' fontSize={16} fontWeight={700} fontFamily={'Museo Slab W01, Arial'} formatter={this.labelFormatter} />
              <LabelList dataKey="name" position="left" offset={10} fontSize={13} fontWeight={300} fontFamily={'Museo Sans W01, Arial'} />
            </Bar>

            <ReferenceLine x={1500} stroke="black" strokeDasharray="3 3" />
            <ReferenceLine x={0} stroke="#FDDDD1" strokeDasharray="3 3" />
          </BarChart>
        </ResponsiveContainer>
      </Fragment>
    );
  }
}

export default TopLTVCPA
